import { constants } from '..';

const setLoyaltyProgramsLoadingAction = flag => ({
  type: constants.loyaltyProgram.SET_LOYALTY_PROGRAMS_LOADING,
  flag,
});

const getLoyaltyProgramsAction = filter => ({
  type: constants.loyaltyProgram.GET_LOYALTY_PROGRAMS,
  filter,
});

const setLoyaltyProgramsAction = (loyaltyPrograms, count, header) => ({
  type: constants.loyaltyProgram.SET_LOYALTY_PROGRAMS,
  loyaltyPrograms,
  count,
  header,
});

const clearLoyaltyProgramsAction = () => ({
  type: constants.loyaltyProgram.CLEAR_LOYALTY_PROGRAMS,
});

const addLoyaltyProgramAction = (body, history) => ({
  type: constants.loyaltyProgram.ADD_LOYALTY_PROGRAM,
  body,
  history,
});

const getLoyaltyProgramAction = id => ({
  type: constants.loyaltyProgram.GET_LOYALTY_PROGRAM,
  id,
});

const setLoyaltyProgramAction = loyaltyProgram => ({
  type: constants.loyaltyProgram.SET_LOYALTY_PROGRAM,
  loyaltyProgram,
});

const editLoyaltyProgramAction = (id, body, history) => ({
  type: constants.loyaltyProgram.EDIT_LOYALTY_PROGRAM,
  id,
  body,
  history,
});

const deleteLoyaltyProgram = (id, history) => ({
  type: constants.loyaltyProgram.DELETE_LOYALTY_PROGRAM,
  id,
  history,
});

export const loyaltyProgramActions = {
  setLoyaltyProgramsLoadingAction,
  getLoyaltyProgramsAction,
  setLoyaltyProgramsAction,
  addLoyaltyProgramAction,
  getLoyaltyProgramAction,
  setLoyaltyProgramAction,
  editLoyaltyProgramAction,
  clearLoyaltyProgramsAction,
  deleteLoyaltyProgram,
};
